/**
 * CMS Redux Middleware.
 * Used to set the CMS mode (draft or production).
 */

import { isEmpty } from 'lodash/fp';
import { REHYDRATE } from 'redux-persist';

import { setPreviewCookie } from '../utils/preview-cookie';
import client from '../client';
import CMS_UPDATE_PREVIEW_OPTIONS from '../action-types';
import getIsServer from '../../utils/get-is-server';

// @ts-expect-error - Automatic, Please fix when editing this file
const setPreviewOptions = (payload) => {
  if (isEmpty(payload)) {
    return;
  }
  client.setAsAtDate(payload?.asAtDate);
  client.setAsAtTime(payload?.asAtTime);
  client.setMode(payload?.mode);
  client.setDataset(payload?.dataset);
  client.setApiToken(payload?.apiToken);
  client.setLiveFilteringToken(payload?.liveFilteringToken);
};

// @ts-expect-error - Automatic, Please fix when editing this file
const cmsMiddleware = () => (next) => (action) => {
  switch (action.type) {
    case REHYDRATE: {
      if (action.key === 'cms') {
        setPreviewOptions(action?.payload);
      }
      break;
    }
    case CMS_UPDATE_PREVIEW_OPTIONS: {
      setPreviewOptions(action?.payload);
      if (!getIsServer()) {
        setPreviewCookie(action.payload);
      }
      break;
    }
    default:
      break;
  }

  return next(action);
};

export default cmsMiddleware;
